module.exports = __webpack_public_path__ + "img/face-no4.9ad94e59.png";